const useSendMail = () => {
  const config = useRuntimeConfig();
  const loading = ref(false);
  const post = async (payload) => {
    try {
      loading.value = true;
      payload.body.model.action = payload.body.model.action || "sendmail";
      payload.body.model.text = payload.body.model.text || "";
      payload.body.model.number = payload.body.model.number || "";
      payload.body.model.name = payload.body.model.name || "";
      payload.body.model.tab = payload.body.model.tab || "";
      payload.body.model.token =
        payload.body.model.token || "aassuyxttpogju54654aAs45AS422KJHH9321647";
      payload.body.model.referrer =
        localStorage.getItem("referrer_value") || "";
      payload.body.model.params = localStorage.getItem("params_value") || "{}";
      payload.body.model.pageUrl = payload.body.model.pageUrl || location.href;
      payload.body.model.companyName = payload.body.model.companyName || "";
      payload.body.model.email = payload.body.model.email || "";
      payload.body.model.vcode = payload.body.model.vcode || "";
      payload.body.model.value =
        payload.body.model.value || payload.body.model.number;
      payload.body.model.activity = payload.body.model.activity || "";
      payload.body.model.numb =
        payload.body.model.numb || payload.body.model.number;
      payload.body.model.cta = pageTitle(location.pathname);
      const options = {
        method: "POST",
        body: JSON.stringify(payload.body),
        initialCache: false,
      };
      const { data, pending, error, refresh } = await useFetch(
        config.public.BASE_URL + `/public/sendMail`,
        options
      );
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: "form_submit", formid: "" });
      if (error.value) {
        console.log(error);
      }
      loading.value = false;
      return {
        data,
        pending,
        error,
        refresh,
      };
    } catch (err) {
      loading.value = false;
      console.error(err);
    }
  };

  const pageTitle = (url) => {
    let path = url ? url.toLowerCase() : null;
    if (path && path[path.length - 1] !== "/") {
      path += "/";
    }
    switch (path) {
      case "/":
        return "صفحه اصلی";
      case "/products/cloud-pbx/":
        return "مرکز تلفن";
      case "/products/internet-phone/":
        return "تلفن اینترنتی";
      case "/products/webchat/":
        return "چت آنلاین";
      case "/products/dedicated-application/":
        return "اپلیکیشن اختصاصی";
      case "/products/management-dashboard/":
        return "پنل مدیریتی";
      case "/products/virtual-office/":
        return "دفتر کار مجازی";
      case "/products/smart-ivr/":
        return "تلفن گویا";
      case "/products/fax/":
        return "فکس اینترنتی";
      case "/connecting-with-crm/":
        return "اتصال به سی ار ام";
      case "/products/cloud-callcenter/":
        return "مرکز تماس";
      case "/prices/":
        return "تعرفه ها";
      case "/contact-us/":
        return "تماس با ما";
      case "/about-us/":
        return "درباره ما";
      case "/support/":
        return "پشتیبانی";
      case "/sales-agent/":
        return "اعطای نمایندگی";
      case "/iran-telecom/":
        return "لندینگ تلکام";
      case "/wf-irantelecom-salesagent/":
        return "درخواست نمایندگی محصولات";
      case "/wf-irantelecom-lead/":
        return "درخواست دمو";
      case "/landing/":
        return "لندینگ مرکز تلفن ابری";
      case "/landing/callcenter/":
        return "لندینگ مرکز تماس";
      case "/landing/fax/":
        return "لندینگ فکس اینترنتی";
      case "/internet-phone/landing/":
        return "لندینگ تلفن ثابت";
      case "/iran-etelecomp/":
        return "لندینگ الکامپ";
      case "/wf-iranelecomp-salesagent/":
        return "درخواست نمایندگی محصولات(الکامپ)";
      case "/wf-iranelecomp-lead/":
        return "درخواست دمو(الکامپ)";
      case "/managers/contact/":
        return "ارتباط با مدیر عامل";
      case "/metama/":
        return "متاما";
      case "/rond/":
        return "شماره‌های مخابرات";
      case "/products/crm/":
          return "مدیریت ارتباط با مشتریان نواتل";
      default:
        return path;
    }
  };
  return { post, loading, pageTitle };
};

export default useSendMail;
